import React from "react";
import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  message,
  Typography,
  Card,
} from "antd";
import LoginSignupScreen from "./loginSignupScreen";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
//Action
import { sendOtpForgetPasswordAction } from "../store/action/shared/authAction";
import { css, keyframes } from "emotion";
import CustomLoaderIcon from "../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";

const { Title } = Typography;

const fadeInAndFloat = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const cardStyle = css`
  animation: ${fadeInAndFloat} 1s forwards,
    ${floatingAnimation} 3s ease-in-out infinite;
`;
function ForgotPassCard() {
  const dispatch = useDispatch();
  const router = useNavigate();

  const sendOtpForgetPassword = useSelector(
    (state) => state.sendOtpForgetPassword
  );
  const { loading, error } = sendOtpForgetPassword;
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    try {
      await dispatch(sendOtpForgetPasswordAction(values.email));
      form.resetFields();
      router(`/login/`);
    } catch (error) {
      message.error("Please try again later");
    }
  };
  return (
    <Row
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Col span={8}>
        <Card
          className={cardStyle}
          style={{
            borderRadius: "32px",
            padding: "30px",
          }}
        >
          <Row>
            <Col span={24}>
              <Title>Forgot Password</Title>
              <p className="subtitle-Body-Large-Subtle subtitle-Body-Large-padding">
                Streamline your Time and Productivity
              </p>
              <Divider />
            </Col>
            <Col span={24}>
              <Form
                form={form}
                name="normal_login"
                className="login-form"
                layout="vertical"
                autoComplete="on"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
              >
                <Row gutter={[0, 0]}>
                  <Col span={24}>
                    <Form.Item
                      name="email"
                      label="Email*"
                      rules={[
                        {
                          required: true,
                          message: "Enter your Email Address",
                        },
                      ]}
                    >
                      <Input placeholder="Enter your Email Address" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </Col>
                  <Col span={24} style={{ marginTop: 10 }}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType={loading ? "button" : "submit"}
                        style={{ marginBottom: "10px" }}
                        loading={loading}
                      >
                        Send Email
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col span={24} align="center">
                    <Link to="/login-via-phone">
                      <Button type="text">Login via Phone</Button>
                    </Link>
                    <Link to="/login">
                      <Button type="text">Login via Email & Password</Button>
                    </Link>
                  </Col>
                  <Col span={24} align="left">
                    <p
                      className="spacer-small"
                      style={{ fontSize: 14, fontWeight: 600 }}
                    >
                      Back to{" "}
                      <Link to="/login">
                        {" "}
                        <span style={{ color: "#f47e63" }}>login</span>
                      </Link>
                    </p>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}

export default ForgotPassCard;
